import React, { Component } from 'react';
import '../lib/scss/bootstrap.scss';
import styled, { ThemeProvider } from 'styled-components';
import { StickyContainer } from 'react-sticky';
import GlobalStyle from '../styles/GlobalStyle';
import Meta from './Meta';

const StyledPage = styled.div`
  background: white;
`;

const theme = {
  primary: '#20c668',
  primaryDark: '#198c4b',

  gray100: '#f8f9fa',
  gray150: '#F5F5F7',
  gray200: '#e9ecef',
  gray300: '#dee2e6',
  gray400: '#ced4da',
  gray500: '#adb5bd',
  gray600: '#6c757d',
  gray700: '#495057',
  gray800: '#343a40',
  gray900: '#212529',

  textColor: '#343a40',

  shadow: '#00000033',

  media: {
    sm: '@media (min-width: 576px)',
    md: '@media (min-width: 768px)',
    lg: '@media (min-width: 992px)',
    xl: '@media (min-width: 1200px)',
  },
};

class Page extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <StyledPage>
          <Meta />
          <GlobalStyle />
          <StickyContainer>{this.props.children}</StickyContainer>
        </StyledPage>
      </ThemeProvider>
    );
  }
}

export default Page;
